/* global TimelineMax */
import React, { PureComponent } from 'react';
import _ from 'lodash';

class AnimatedEllipsis extends PureComponent {

    constructor(props) {
        super(props);

        this.dot0 = null;
        this.dot1 = null;
        this.dot2 = null;

        this.timeline = null;
    }

    componentDidMount() {
        const timeline = new TimelineMax({
            repeat: -1,
        });

        this.timeline = timeline;

        _.times(3, (i) => {
            const dot = this[`dot${i}`];
            timeline.fromTo(dot, 0.3, {
                alpha: 0,
            }, {
                alpha: 1,
                yoyo: true,
                repeat: 1,
            }, i * 0.1);
        });
    }

    componentWillUnmount() {
        if (this.timeline) {
            this.timeline.kill();
            this.timeline = null;
        }
    }

    render() {
        return (
            <div className="animated-ellipsis">
                <span className="dot dot-0" ref={(el) => { this.dot0 = el; }}>.</span>
                <span className="dot dot-1" ref={(el) => { this.dot1 = el; }}>.</span>
                <span className="dot dot-2" ref={(el) => { this.dot2 = el; }}>.</span>
            </div>
        );
    }
}

module.exports = AnimatedEllipsis;



// WEBPACK FOOTER //
// ./js/components/partials/AnimatedEllipsis.jsx